module.exports = __webpack_public_path__ + "img/icon_shopping_cart.27816389.svg";